import {Inject, Injectable, NgZone, PLATFORM_ID} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '..';
import {EMPTY, fromEvent, merge, Observable, Subject, timer} from 'rxjs';
import { switchMap, take, takeUntil, startWith, throttleTime } from 'rxjs/operators';
import {isPlatformBrowser} from "@angular/common";

@Injectable({
  providedIn: 'root',
})
export class InactivityService {
  private inactivityDuration = 15 * 60 * 1000; // 15 хвилин
  private destroy$: Subject<void> | null = null;
  private isActive = false;
  private activity$: Observable<Event> = EMPTY;

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.activity$ = merge(
        fromEvent(document, 'mousemove').pipe(throttleTime(5000)),
        fromEvent(document, 'mousedown'),
        fromEvent(document, 'keydown'),
        fromEvent(document, 'touchstart'),
        fromEvent(document, 'click'),
        fromEvent(document, 'scroll').pipe(throttleTime(5000))
      );
    }
  }

  init(duration?: number): void {
    if (this.isActive) {
      console.warn('InactivityService вже активний');
      return;
    }

    if (duration && duration > 0) {
      this.inactivityDuration = duration;
    }

    this.destroy$ = new Subject<void>();
    this.isActive = true;

    console.log(`InactivityService started (${this.inactivityDuration / 1000}s)`);

    this.ngZone.runOutsideAngular(() => {
      this.activity$
        .pipe(
          startWith(null),
          switchMap(() => timer(this.inactivityDuration)),
          takeUntil(this.destroy$!)
        )
        .subscribe(() => this.handleLogout());
    });
  }

  stop(): void {
    if (!this.isActive || !this.destroy$) {
      return;
    }

    console.log('InactivityService stopped');

    this.destroy$.next();
    this.destroy$.complete();
    this.destroy$ = null;
    this.isActive = false;
  }

  private handleLogout(): void {
    console.log('InactivityService - logout');

    this.stop();

    this.ngZone.run(() => {
      this.authService
        .logoutUser()
        .pipe(take(1))
        .subscribe({
          next: () => {
            this.router.navigate(['/start']).then(() => {
              if (isPlatformBrowser(this.platformId)) {
                location.reload();
              }
            });
          },
          error: (err) => {
            console.error('Помилка logout:', err);
            this.router.navigate(['/start']).then(() => {
              if (isPlatformBrowser(this.platformId)) {
                location.reload();
              }
            });
          }
        });
    });
  }
}
